import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {FormBuilder, FormGroup, NgForm, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {RoleAnagrafModel} from '../../../../models/RoleAnagrafModel';
import {RoleAnagrafService} from '../../../general-services/service-role-anagraf/role-anagraf.service';
import * as toastr from 'toastr';

@Component({
  selector: 'app-new-role-anagraf',
  templateUrl: './new-role-anagraf.component.html',
  styleUrls: ['./new-role-anagraf.component.scss']
})
export class NewRoleAnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {
  roleAnagraf: RoleAnagrafModel;
  formValidator: FormGroup;
  formBuilder: FormBuilder;
  saveSubscribe: Subscription;

  constructor(private route: ActivatedRoute, private router: Router,
    private roleAnagrafService: RoleAnagrafService) {
    super();

    this.roleAnagraf = new RoleAnagrafModel();

    this.formBuilder = new FormBuilder();

    this.formValidator = this.formBuilder.group({
      code: [this.roleAnagraf.code, [Validators.required]],
      description: [this.roleAnagraf.description, [Validators.required]]
    });
  }

  ngOnInit() {

  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.ROLE_ANAGRF]);
  }

  save(event: any, form: NgForm, clickSalva ?: boolean) {
    if (event.key === 'Enter' || clickSalva) {
      event.preventDefault();
      this.roleAnagraf.code = this.formValidator.value.code;
      this.roleAnagraf.description = this.formValidator.value.description;
      this.saveSubscribe = this.roleAnagrafService.save(this.roleAnagrafService.baseUrl, this.roleAnagraf).subscribe(
        (result: any) => {
          if (result === -1) {
            toastr.options.timeout = 5000;
            toastr.warning('Duplicate item, Role Cod already exists', 'Warning');
          } else {
            toastr.warning('Element was added with success', 'Warning');
            this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.ROLE_ANAGRF]);
          }
        });
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
    this.saveSubscribe.unsubscribe();
  }
}
}
